import axios from "axios";
import { ticketBaseURL } from "../configs/api";

export const getPlans = () => {
    return getFetch(`rdRentalPlan`)
}

export const getPlan = (primaryKey: string) => {
    return getFetch(`rdRentalPlan/${primaryKey}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}